import { EnergyRatingItem } from "@/types";
export const GBRatings: EnergyRatingItem[] = [
  {
    min: 92,
    code: "A",
    color: "#028B5F",
  },
  {
    min: 81,
    max: 91,
    code: "B",
    color: "#1AB25B",
  },
  {
    min: 69,
    max: 80,
    code: "C",
    color: "#8ED343",
  },
  {
    min: 55,
    max: 68,
    code: "D",
    color: "#F5C900",
  },
  {
    min: 39,
    max: 54,
    code: "E",
    color: "#F9B164",
  },
  {
    min: 21,
    max: 38,
    code: "F",
    color: "#F48422",
  },
  {
    min: 1,
    max: 20,
    code: "G",
    color: "#F1213E",
  },
  {
    min: 0,
    max: 0,
    code: "Unknown",
    color: "#404040",
  },
];

export const ROIRatings: EnergyRatingItem[] = [
  {
    min: 50,
    code: "A",
    color: "#028B5F",
  },
  {
    min: 125,
    code: "B",
    color: "#1AB25B",
  },
  {
    min: 200,
    code: "C",
    color: "#8ED343",
  },
  {
    min: 260,
    code: "D",
    color: "#F5C900",
  },
  {
    min: 340,
    code: "E",
    color: "#F9B164",
  },
  {
    min: 380,
    code: "F",
    color: "#F48422",
  },
  {
    min: 450,
    code: "G",
    color: "#F1213E",
  },
  {
    min: 0,
    code: "Unknown",
    color: "#404040",
  },
];
